"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.webRTC = exports.joinChatByJid = exports.loadLastUserActivity = exports.setOnReconnectListener = exports.setOnDisconnectedListener = exports.setOnMessageTypingListener = exports.setLastUserActivityListener = exports.removePrivacyList = exports.setDefaultPrivacyList = exports.getPrivacyListNames = exports.updatePrivacyList = exports.createPrivacyList = exports.loadPrivacyList = exports.DEFAULT_BLACKLIST_NAME = exports.loadDialogsUnreadMessagesCount = exports.getUserByName = exports.getUserByLogin = exports.findUsersByFilter = exports.loadUserById = exports.getContacts = exports.confirmSubscribe = exports.setSubscribeListener = exports.removeUser = exports.addUser = exports.setContactListListener = exports.getFileLink = exports.uploadFile = exports.setSentMessageCallback = exports.setKickOccupantListener = exports.setMessagesErrorListener = exports.setOnDeliveredStatusListener = exports.setOnReadStatusListener = exports.sendDeliveredStatus = exports.sendReadStatus = exports.sendSystemMessageEvent = exports.setOnSystemMessagesListener = exports.setMessagesListener = exports.getMessagesCount = exports.getDialogHistory = exports.leaveDialog = exports.deleteDialog = exports.editGroupDialog = exports.createGroupDialog = exports.createDialog = exports.deleteMessage = exports.sendMessageToOpponent = exports.genMessageId = exports.getDialogs = exports.logout = exports.connect = exports.setSession = exports.qbInit = void 0;
// @ts-nocheck
/* istanbul ignore file */
var quickblox_flash_1 = __importDefault(require("@flash-chat/quickblox-flash"));
var logger_1 = __importDefault(require("./logger"));
var types_1 = require("./types");
var getUserFromQBData_1 = require("./users/getUserFromQBData");
var promisify_1 = require("./utils/promisify");
var log = logger_1.default.module('QBAdapter');
var qbPromisify = promisify_1.promisify(quickblox_flash_1.default);
var promisifyPrivacyList = function () { return promisify_1.promisify(quickblox_flash_1.default.chat.privacylist); };
var isLoggerSet = false;
exports.qbInit = function (creds, config) {
    log.info('Init QB', { config: config, creds: creds });
    quickblox_flash_1.default.init(creds.appId, creds.authKey, creds.authSecret, config);
};
exports.setSession = function (session) {
    quickblox_flash_1.default.service.setSession(session);
};
exports.connect = function (user) {
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.connect(user, function (err, result) {
            if (err) {
                reject(err);
                return;
            }
            resolve(result);
        });
    });
};
exports.logout = function () {
    quickblox_flash_1.default.chat.disconnect();
};
exports.getDialogs = function (filter) {
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.dialog.list(filter, function (err, result) {
            if (err) {
                log.error('Error in getDialogs', { err: err, result: result });
                reject(err);
                return;
            }
            if (!result || !result.items || !Object.keys(result)) {
                log.error('Error in getDialogs', { err: err, result: result });
            }
            resolve(result);
        });
    });
};
exports.genMessageId = function () { return quickblox_flash_1.default.chat.helpers.getBsonObjectId(); };
exports.sendMessageToOpponent = function (opponentId, message, messageId, dialogId, type, attachment, customParams, markable) {
    if (attachment === void 0) { attachment = []; }
    var msg = {
        id: messageId,
        type: type,
        body: message,
        extension: __assign({ dialog_id: dialogId, save_to_history: 1, attachments: attachment }, customParams),
        markable: markable ? 1 : 0,
    };
    log.verbose('Send message', { opponentId: opponentId, msg: msg });
    return quickblox_flash_1.default.chat.send(opponentId, msg);
};
exports.deleteMessage = function (_a) {
    var messageId = _a._id;
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.message.delete(messageId, { force: 1 }, function (err, res) {
            if (err) {
                reject(err);
                return;
            }
            resolve(res);
        });
    });
};
var DialogType;
(function (DialogType) {
    DialogType[DialogType["PUBLIC_GROUP"] = 1] = "PUBLIC_GROUP";
    DialogType[DialogType["GROUP"] = 2] = "GROUP";
    DialogType[DialogType["PRIVATE"] = 3] = "PRIVATE";
})(DialogType || (DialogType = {}));
exports.createDialog = function (_a) {
    var occupant = _a.occupant, data = _a.data;
    return qbPromisify(quickblox_flash_1.default.chat.dialog.create)({
        type: DialogType.PRIVATE,
        occupants_ids: [occupant],
        data: data,
    });
};
exports.createGroupDialog = function (_a) {
    var occupants = _a.occupants, name = _a.name, data = _a.data;
    return qbPromisify(quickblox_flash_1.default.chat.dialog.create)({
        type: DialogType.GROUP,
        occupants_ids: occupants,
        name: name,
        data: data,
    });
};
exports.editGroupDialog = function (_a) {
    var dialogId = _a.dialogId, name = _a.name, add = _a.add, remove = _a.remove;
    var params = {};
    if (name)
        params.name = name;
    if (add)
        params.push_all = { occupants_ids: add };
    if (remove)
        params.pull_all = { occupants_ids: remove };
    return qbPromisify(quickblox_flash_1.default.chat.dialog.update)(dialogId, params);
};
exports.deleteDialog = function (dialogsIds, options) {
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.dialog.delete(dialogsIds, options, function (err) {
            if (err) {
                reject(err);
                return;
            }
            resolve();
        });
    });
};
exports.leaveDialog = function (dialogId) {
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.muc.leave(dialogId, function (err) {
            if (err) {
                reject(err);
                return;
            }
            resolve();
        });
    });
};
exports.getDialogHistory = function (_a) {
    var dialogId = _a.dialogId, params = __rest(_a, ["dialogId"]);
    var defaultParams = {
        chat_dialog_id: dialogId,
        sort_desc: 'date_sent',
        limit: 100,
        skip: 0,
    };
    var messageListParams = __assign(__assign({}, defaultParams), params);
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.message.list(messageListParams, function (err, res) {
            if (err) {
                reject(err);
                return;
            }
            resolve(res);
        });
    });
};
exports.getMessagesCount = function (dialogId) {
    var params = {
        chat_dialog_id: dialogId,
        count: 1,
    };
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.message.list(params, function (err, res) {
            if (err) {
                reject(err);
                return;
            }
            resolve(res.items.count);
        });
    });
};
exports.setMessagesListener = function (cb) {
    quickblox_flash_1.default.chat.onMessageListener = function (userId, income) {
        log.verbose('Received message', { userId: userId, income: income });
        cb({ userId: userId, message: income });
    };
};
exports.setOnSystemMessagesListener = function (onMessageDelete, onJoinGroup) {
    quickblox_flash_1.default.chat.onSystemMessageListener = function (msg) {
        if (msg.body === types_1.TSystemEvents.DELETE_MESSAGE) {
            log.verbose('Received event delete message', msg);
            onMessageDelete(msg.extension._id);
        }
        if (msg.body === types_1.TSystemEvents.JOIN_GROUP) {
            log.verbose('Received event join group', msg);
            onJoinGroup({
                userId: msg.userId,
                dialogId: msg.extension._id,
            });
        }
    };
};
exports.sendSystemMessageEvent = function (userId, message) { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                log.verbose('sendSystemMessage', { userId: userId, message: message });
                return [4 /*yield*/, quickblox_flash_1.default.chat.sendSystemMessage(userId, message)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                if (e_1.name === 'ChatNotConnectedError') {
                    // not connected to chat
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.sendReadStatus = function (params) {
    log.verbose('Send "read" status', { params: params });
    quickblox_flash_1.default.chat.sendReadStatus(params);
};
exports.sendDeliveredStatus = function (params) {
    log.verbose('Send "delivered" status', { params: params });
    quickblox_flash_1.default.chat.sendDeliveredStatus(params);
};
exports.setOnReadStatusListener = function (cb) {
    quickblox_flash_1.default.chat.onReadStatusListener = function (messageId, dialogId, userId) {
        log.verbose('Received "read" status', { messageId: messageId, dialogId: dialogId, userId: userId });
        cb({ messageId: messageId, dialogId: dialogId, userId: userId });
    };
};
exports.setOnDeliveredStatusListener = function (cb) {
    quickblox_flash_1.default.chat.onDeliveredStatusListener = function (messageId, dialogId, userId) {
        log.verbose('Received "delivered" status', { messageId: messageId, dialogId: dialogId, userId: userId });
        cb({ messageId: messageId, dialogId: dialogId, userId: userId });
    };
};
exports.setMessagesErrorListener = function (event) {
    quickblox_flash_1.default.chat.onMessageErrorListener = function (messageId, error) {
        log.error('Message error', { messageId: messageId, error: error });
        event({ messageId: messageId, error: error });
    };
};
exports.setKickOccupantListener = function (cb) {
    quickblox_flash_1.default.chat.onKickOccupant = function (messageId, initiatorUserId) {
        cb({ messageId: messageId, initiatorUserId: initiatorUserId });
    };
};
exports.setSentMessageCallback = function (cb) {
    quickblox_flash_1.default.chat.onSentMessageCallback = function (messageLost, messageSent) {
        log.error('Sent message', { messageLost: messageLost, messageSent: messageSent });
        cb({ messageLost: messageLost, messageSent: messageSent });
    };
};
exports.uploadFile = function (file) {
    return new Promise(function (resolve, reject) {
        var params = {
            name: file.name,
            file: file,
            type: file.type,
            size: file.size,
            public: false,
        };
        quickblox_flash_1.default.content.createAndUpload(params, function (err, res) {
            if (err) {
                reject(err);
                return;
            }
            resolve(res);
        });
    });
};
exports.getFileLink = function (appToken, uid) {
    return quickblox_flash_1.default.content.publicUrl(uid) + "/download.json?token=" + appToken;
};
exports.setContactListListener = function (cb) {
    quickblox_flash_1.default.chat.onContactListListener = function (userId, type) {
        cb({ userId: userId, isOnline: type !== 'unavailable' });
    };
};
exports.addUser = function (userId) {
    return new Promise(function (resolve) {
        quickblox_flash_1.default.chat.roster.add(userId, function () { return resolve(userId); });
    });
};
exports.removeUser = function (userId) {
    return new Promise(function (resolve) {
        quickblox_flash_1.default.chat.roster.remove(userId, function () { return resolve(userId); });
    });
};
exports.setSubscribeListener = function (cb) {
    quickblox_flash_1.default.chat.onSubscribeListener = function (userId) {
        cb(userId);
    };
};
exports.confirmSubscribe = function (userId) {
    return new Promise(function (resolve) {
        return quickblox_flash_1.default.chat.roster.confirm(userId, function () { return resolve(userId); });
    });
};
exports.getContacts = function () {
    var idx = Object.keys(quickblox_flash_1.default.chat.roster.contacts);
    if (idx.length === 0) {
        return Promise.resolve({
            items: [],
            total_entries: 0,
            limit: 10,
            skip: 0,
        });
    }
    return _getAllUsers({ filter: [{ field: 'id', param: 'in', value: idx }] });
};
var _getAllUsers = function (filter) {
    if (filter === void 0) { filter = {}; }
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.users.listUsers(filter, function (err, result) {
            if (err) {
                reject(err);
                return;
            }
            if (result && result.items) {
                var items = result.items.map(function (QBItem) { return ({
                    user: getUserFromQBData_1.getUserFromQBData(QBItem),
                }); });
                resolve(__assign(__assign({}, result), { items: items }));
            }
        });
    });
};
exports.loadUserById = function (qbUserId) {
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.users.get(qbUserId, function (error, response) {
            if (error) {
                reject(error);
                return;
            }
            if (response) {
                resolve(__assign({}, response));
                return;
            }
            reject(new Error('unprocessable error'));
        });
    });
};
exports.findUsersByFilter = function (_a) {
    var per_page = _a.per_page, filters = _a.filters;
    return __awaiter(void 0, void 0, void 0, function () {
        var filter, items;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (Array.isArray(filters)) {
                        filter = filters;
                    }
                    else {
                        filter = [filters];
                    }
                    return [4 /*yield*/, _getAllUsers({ per_page: per_page, filter: filter })];
                case 1:
                    items = (_b.sent()).items;
                    return [2 /*return*/, items.map(function (item) { return item.user; })];
            }
        });
    });
};
exports.getUserByLogin = function (login) { return __awaiter(void 0, void 0, void 0, function () {
    var items;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, _getAllUsers({
                    filter: [{ field: 'login', param: 'eq', value: login }],
                })];
            case 1:
                items = (_a.sent()).items;
                return [2 /*return*/, items.length > 0 ? items[0].user : null];
        }
    });
}); };
exports.getUserByName = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    var items;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, _getAllUsers({
                    filter: [{ field: 'full_name', param: 'eq', value: name }],
                })];
            case 1:
                items = (_a.sent()).items;
                return [2 /*return*/, items.length > 0 ? items[0].user : null];
        }
    });
}); };
exports.loadDialogsUnreadMessagesCount = function (dialogs) {
    var chat_dialog_ids = Array.isArray(dialogs) ? dialogs : [dialogs];
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.message.unreadCount({ chat_dialog_ids: chat_dialog_ids }, function (err, res) {
            if (err) {
                reject(err);
                return;
            }
            resolve(res);
        });
    });
};
exports.DEFAULT_BLACKLIST_NAME = 'BlackList';
exports.loadPrivacyList = function (listName) {
    return promisifyPrivacyList()(quickblox_flash_1.default.chat.privacylist.getList)(listName).catch(function (error) {
        if (error.code === 404) {
            return null;
        }
        throw error;
    });
};
exports.createPrivacyList = function (privacyList) {
    return promisifyPrivacyList()(quickblox_flash_1.default.chat.privacylist.create)(privacyList);
};
exports.updatePrivacyList = function (privacyList) {
    return promisifyPrivacyList()(quickblox_flash_1.default.chat.privacylist.update)(privacyList);
};
exports.getPrivacyListNames = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, promisifyPrivacyList()(quickblox_flash_1.default.chat.privacylist.getNames)()];
    });
}); };
exports.setDefaultPrivacyList = function (listName) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, promisifyPrivacyList()(quickblox_flash_1.default.chat.privacylist.setAsDefault)(listName)];
    });
}); };
exports.removePrivacyList = function (listName) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, promisifyPrivacyList()(quickblox_flash_1.default.chat.privacylist.remove)(listName)];
    });
}); };
exports.setLastUserActivityListener = function (callback) {
    quickblox_flash_1.default.chat.onLastUserActivityListener = function (userId, seconds) {
        log.verbose('Received last user activity', { userId: userId, seconds: seconds });
        callback({ userId: userId, seconds: seconds });
    };
};
exports.setOnMessageTypingListener = function () {
    // QB.chat.onMessageTypingListener((isTyping: boolean, userId: UserId, dialogId: DialogId) => {
    //   log.verbose('User typing', {isTyping, userId, dialogId});
    // });
};
exports.setOnDisconnectedListener = function () {
    // QB.chat.onDisconnectedListener(() => {
    //   log.verbose('Disconnect');
    // });
};
exports.setOnReconnectListener = function () {
    // QB.chat.onReconnectListener(() => {
    //   log.verbose('Reconnect');
    // });
};
exports.loadLastUserActivity = function (userId) {
    log.verbose('Request last user activity', { userId: userId });
    try {
        quickblox_flash_1.default.chat.getLastUserActivity(userId);
    }
    catch (error) {
        if (error.message && error.message.includes('Chat is not connected')) {
            log.info('Chat is not connected', { error: error });
            return;
        }
        throw error;
    }
};
exports.joinChatByJid = function (jid) {
    return new Promise(function (resolve, reject) {
        quickblox_flash_1.default.chat.muc.join(jid, function (error, res) {
            if (error) {
                return reject(error);
            }
            resolve(res);
        });
    });
};
// Video and Audio calls
var setLogger = function (callsLogger) {
    if (isLoggerSet) {
        log.debug('logger already set');
        return;
    }
    Object.keys(callsLogger).forEach(function (callbackName) {
        var oldListener = typeof quickblox_flash_1.default.webrtc[callbackName] === 'function'
            ? quickblox_flash_1.default.webrtc[callbackName]
            : function () { return null; };
        quickblox_flash_1.default.webrtc[callbackName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            callsLogger[callbackName].apply(callsLogger, args);
            oldListener.apply(void 0, args);
        };
    });
    isLoggerSet = true;
};
var createNewSession = function (calleesIds, callType) {
    return quickblox_flash_1.default.webrtc.createNewSession(calleesIds, callType, null, {});
};
var setOnCallListener = function (cb) {
    quickblox_flash_1.default.webrtc.onCallListener = cb;
};
// eslint-disable-next-line no-return-assign
var setOnUserNotAnswerListener = function (cb) { return (quickblox_flash_1.default.webrtc.onUserNotAnswerListener = cb); };
// eslint-disable-next-line no-return-assign
var setOnAcceptCallListener = function (cb) {
    return (quickblox_flash_1.default.webrtc.onAcceptCallListener = function (session, userId, ext) {
        // eslint-disable-next-line no-param-reassign
        session.callAcceptedTimestampRoxy = Date.now();
        cb(session, userId, ext);
    });
};
// eslint-disable-next-line no-return-assign
var setOnRejectCallListener = function (cb) { return (quickblox_flash_1.default.webrtc.onRejectCallListener = cb); };
// eslint-disable-next-line no-return-assign
var setOnStopCallListener = function (cb) { return (quickblox_flash_1.default.webrtc.onStopCallListener = cb); };
// eslint-disable-next-line no-return-assign
var setOnUpdateCallListener = function (cb) { return (quickblox_flash_1.default.webrtc.onUpdateCallListener = cb); };
var setOnSessionCloseListener = function (cb) {
    quickblox_flash_1.default.webrtc.onSessionCloseListener = cb;
};
var getMediaTypes = function () { return quickblox_flash_1.default.webrtc.CallType; };
var setOnRemoteStreamListener = function (cb) {
    quickblox_flash_1.default.webrtc.onRemoteStreamListener = function (session, userId, remoteStream) {
        // todo
        var DOMElementID = session.callType === getMediaTypes().VIDEO
            ? 'video-webrtc-remote'
            : 'audio-webrtc-remote';
        // eslint-disable-next-line no-param-reassign
        session.remoteStreamRoxy = remoteStream;
        if (session.callType === getMediaTypes().AUDIO) {
            session.attachMediaStream(DOMElementID, remoteStream);
        }
        cb(session, userId, remoteStream);
    };
};
// eslint-disable-next-line no-return-assign
var setOnSessionConnectionStateChangedListener = function (cb) { return (quickblox_flash_1.default.webrtc.onSessionConnectionStateChangedListener = cb); };
exports.webRTC = {
    setLogger: setLogger,
    createNewSession: createNewSession,
    setOnCallListener: setOnCallListener,
    setOnUserNotAnswerListener: setOnUserNotAnswerListener,
    setOnAcceptCallListener: setOnAcceptCallListener,
    setOnRejectCallListener: setOnRejectCallListener,
    setOnStopCallListener: setOnStopCallListener,
    setOnUpdateCallListener: setOnUpdateCallListener,
    setOnSessionCloseListener: setOnSessionCloseListener,
    setOnSessionConnectionStateChangedListener: setOnSessionConnectionStateChangedListener,
    setOnRemoteStreamListener: setOnRemoteStreamListener,
    setOnSystemMessagesListener: exports.setOnSystemMessagesListener,
    getMediaTypes: getMediaTypes,
};
//# sourceMappingURL=QBAdapter.js.map